import * as React from 'react';
import { Steps } from '../types.js';
import ConclusionStep from './ConclusionStep.js';
import EmojiStep from './EmojiStep.js';
import ReasonStep from './ReasonStep.js';

const StepsWrapper = ({ step  })=>{
    switch(step){
        case Steps.Emoji:
            return /*#__PURE__*/ React.createElement(EmojiStep, null);
        case Steps.Reason:
            return /*#__PURE__*/ React.createElement(ReasonStep, null);
        case Steps.Conclusion:
            return /*#__PURE__*/ React.createElement(ConclusionStep, null);
        default:
            return null;
    }
};
var StepsWrapper$1 = StepsWrapper;

export { StepsWrapper$1 as default };
